export { default as ManualOrAutomaticRiderAssignment } from './manual-or-automatic-rider-assignment';
